var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAppealGray = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 6.33993H14.5V7.8759H5.5V6.33993Z",
  fill: "#CCE3F0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13 9.41187H5.5V10.9478H13V9.41187Z",
  fill: "#CCE3F0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.81053 19.1192C5.68918 19.2272 5.5 19.139 5.5 18.9743V14.7878H3.25C2.83579 14.7878 2.5 14.4439 2.5 14.0198V3.26799C2.5 2.84384 2.83579 2.5 3.25 2.5H16.75C17.1642 2.5 17.5 2.84384 17.5 3.26799V14.0198C17.5 14.4439 17.1642 14.7878 16.75 14.7878H10.675L5.81053 19.1192ZM7 13.2518V16.0246L10.114 13.2518H16V4.03597H4V13.2518H7Z",
  fill: "#CCE3F0"
})));
export default SvgAppealGray;